import { __decorate, __metadata } from "tslib";
import { action, observable } from 'mobx';
var HardwareStore = (function () {
    function HardwareStore(rootStore) {
        var _this = this;
        this.rootStore = rootStore;
        this.modems = [];
        this.loading = true;
        this.hardwareDetails = null;
        this.getInitialStoreState = function () { return ({
            formInitialValues: _this.getInitialFormValues(),
            formValues: null,
        }); };
        this.getInitialFormValues = function () { return ({
            hardwareCode: '',
            hardwareMeshCode: '',
        }); };
        this.hardwareDetails = this.getInitialStoreState();
    }
    HardwareStore.prototype.setDetailsFromForm = function (details) {
        this.hardwareDetails.formValues = details;
    };
    HardwareStore.prototype.eligibleModems = function (contractCode, voipIncluded) {
        var _this = this;
        var contract = this.rootStore.planStore.getContract(this.rootStore.planStore.planDetails.formValues.contractCode);
        if (this.rootStore.config.wholesaleCustomerCode === 'BDF') {
            return this.modems;
        }
        else if (contract.length === 24 && contract.planType === 'Bundle') {
            return this.modems
                .filter(function (modem) {
                return _this.rootStore.planStore
                    .getContract(contractCode)
                    .hardwareCodes.includes(modem.code.toString()) &&
                    modem.code.endsWith('BUNDLE');
            })
                .sort(function (a, b) {
                return a.currentPricing['sellInc'] -
                    b.currentPricing['sellInc'];
            });
        }
        else {
            return this.modems
                .filter(function (modem) {
                return !(voipIncluded && modem.code === 'MODW9960') &&
                    (_this.rootStore.planStore
                        .getContract(contractCode)
                        .hardwareCodes.includes(modem.code.toString()) &&
                        modem.isModem &&
                        !modem.code.endsWith('RMA') &&
                        !modem.code.endsWith('DOA')) &&
                    !modem.code.endsWith('PROMO');
            })
                .sort(function (a, b) {
                return a.currentPricing['sellInc'] -
                    b.currentPricing['sellInc'];
            });
        }
    };
    HardwareStore.prototype.meshHardwares = function (contractCode) {
        var _this = this;
        return this.modems
            .filter(function (modem) {
            return _this.rootStore.planStore
                .getContract(contractCode)
                .hardwareCodes.includes(modem.code.toString()) &&
                !modem.isModem;
        })
            .sort(function (a, b) {
            return a.currentPricing['sellInc'] -
                b.currentPricing['sellInc'];
        });
    };
    HardwareStore.prototype.isLoading = function (loading) {
        this.loading = loading;
    };
    HardwareStore.prototype.loadHardware = function () {
        var _this = this;
        this.rootStore.api.V1.Lookup.Products.Hardware().then(function (r) {
            _this.modems = r.products;
            _this.isLoading(false);
        });
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], HardwareStore.prototype, "modems", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], HardwareStore.prototype, "loading", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], HardwareStore.prototype, "hardwareDetails", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HardwareStore.prototype, "setDetailsFromForm", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], HardwareStore.prototype, "eligibleModems", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], HardwareStore.prototype, "meshHardwares", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HardwareStore.prototype, "isLoading", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HardwareStore.prototype, "loadHardware", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], HardwareStore.prototype, "getInitialStoreState", void 0);
    return HardwareStore;
}());
export { HardwareStore };
//# sourceMappingURL=HardwareStore.js.map